export const REMOTE_CONFIG_QUERY_KEY = ["remoteConfig"] as const;

export type RemoteConfigQueryKey = typeof REMOTE_CONFIG_QUERY_KEY;
